export default function valueOrEmpty(value, formatter = (value) => value) {
  return value ? formatter(value) : "---";
}
